/**
 * Name: Navigation
 */

import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";

export default class Navigation extends Collapsible {
  static settings = {
    control: '.js-navigation-control',
    target: '.js-navigation-megamenu',
    close: '.js-navigation-close',
  };

  #control;
  #closeButtons;


  constructor (element, options = {}) {
    super(element, {
      ...Navigation.settings,
      ...options,
    });

    this.#control = this.element.querySelector('.js-navigation-control');
    this.#closeButtons = this.element.querySelectorAll('.js-navigation-close');
  }

  open () {
    super.open();
    document.querySelector('header').classList.add('megamenu-is-open');
    this.#control.classList.add('active');
    // Le header est en `position: sticky` (toujours visible) : on évite le
    // scroll-into-view automatique du navigateur, qui recalcule sa position
    // comme si le header n'était pas sticky et ramène la page en haut.
    this.target.focus({ preventScroll: true });

    setTimeout(() => {
      this.target.classList.add('open');
    }, 2);
  }

  close (refocus = true) {
    document.querySelector('header').classList.remove('megamenu-is-open');
    super.close(refocus);
    this.#control.classList.remove('active');
  }

  // Ne ferme pas automatiquement quand le focus sort du megamenu : le
  // reste de la page est déjà rendu inerte pendant qu'il est ouvert, donc
  // il n'y a pas de risque de piège clavier. Fermer en réaction à un focus
  // qui s'échappe s'est révélé instable avec VoiceOver (son curseur se
  // désynchronise du focus réel) — seules les fermetures explicites
  // (bouton, Échap) restent fiables.
  _handleFocusout () {}

  mount () {
    super.mount();
    this.#control.removeAttribute('aria-haspopup');
    this.#closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.close()
        setTimeout(() => {
          this.target.classList.remove('open');
        }, 2);
      });
    });
  }

  unmount () {
    super.unmount();
    this.target.classList.remove('megamenu-is-open');
    this.#closeButtons.forEach(button => {
      button.removeEventListener('click', () => {
        this.close()
        setTimeout(() => {
          this.target.classList.remove('open');
        }, 2);
      });
    });
  }
}
